<template>
  <el-dialog width="700px" title="Credit Review" :close-on-click-modal="false" :visible.sync="visible" top="3vh">
    <div slot="title" class="headline">
      Credit Review
      <span>(This is to apply approval for paying later instead of in advance.)</span>
    </div>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-width="160px">
      <el-form-item label="Apply Reason" v-if="detail && detail.credit">{{ detail.credit.applyReason }}</el-form-item>
      <el-form-item label="Apply Attachments" v-if="detail && detail.credit && detail.credit.attachmentUrls">
        <div v-for="item in detail.credit.attachmentUrls" :key="item.url">
          <a :href="item.url" target="_target">{{ item.name }}</a>
        </div>
      </el-form-item>
      <el-form-item label="Agreed to pay later" prop="creditStatus">
        <el-radio-group v-model="dataForm.creditStatus">
          <el-radio label="REJECTED">Rejected</el-radio>
          <el-radio label="PASSED">Pass</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Reject Reason" prop="auditRemark" v-if="dataForm.creditStatus == 'REJECTED'">
        <el-input
          v-model="dataForm.auditRemark"
          type="textarea"
          :rows="5"
          :autosize="{ minRows: 4 }"
          resize="none"
          placeholder="Reason"
          v-regexFilter="halfWidthRegex"
        ></el-input>
      </el-form-item>
      <el-form-item label="Attachments" prop="attachmentUrls">
        <el-multiple-file-uploader v-model="dataForm.attachmentUrls"></el-multiple-file-uploader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        creditStatus: "PASSED",
        auditRemark: "",
        attachmentUrls: [],
      },
      dataRule: {
        creditStatus: [{ required: true, message: "please select", trigger: "submit" }],
      },
      submitLoading: false,
    };
  },
  computed: {
    ...mapState("finance", ["detail"]),
  },
  methods: {
    ...mapActions("finance", ["doAuditCredit"]),
    async init() {
      this.submitLoading = false;
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          let credit = JSON.parse(JSON.stringify(this.detail.credit || {}));
          credit.auditRemark = this.dataForm.auditRemark;
          this.doAuditCredit({ ...this.dataForm, credit })
            .then(() => {
              this.$message({
                message: "success",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.visible = false;
                },
              });
            })
            .catch(msg => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.headline {
  font-size: 16px;
  font-weight: 500;

  span {
    font-size: 14px;
    color: #667288;
  }
}
</style>
